// 11sight component added
import React, { useEffect, useRef, useState } from 'react';
import { getCurrentConferenceUrl } from 'jitsi/base/connection/functions';
import { translate } from 'jitsi/base/i18n/functions';
import Icon from 'jitsi/base/icons/components/Icon';
import { IconCopy, IconCheck } from 'jitsi/base/icons/svg';
import { connect } from 'react-redux';
import { copyText } from 'jitsi/base/util/copyText.web';
import { getDecodedURI } from 'jitsi/base/util/uri';
import { withStyles } from '@mui/styles';
import cx from 'clsx';
const COPY_TIMEOUT = 2000;
/**
 * Component used to copy meeting url on prejoin page.
 */
export const CopyMeetingUrl = (props) => {
    const textarea = useRef(null);
    const [showCopyLink, setShowCopyLink] = useState(false);
    const [showLinkCopied, setShowLinkCopied] = useState(false);
    /**
     * Initializes a new {@code Prejoin} instance.
     *
     * @inheritdoc
     */
    // constructor(props: Props) {
    //   super(props);
    //   this.state = {
    //     showCopyLink: false,
    //     showLinkCopied: false,
    //   };
    //   this._copyUrl = this._copyUrl.bind(this);
    //   this._hideCopyLink = this._hideCopyLink.bind(this);
    //   this._hideLinkCopied = this._hideLinkCopied.bind(this);
    //   this._showCopyLink = this._showCopyLink.bind(this);
    //   this._showLinkCopied = this._showLinkCopied.bind(this);
    //   this._copyUrlAutomatically = this._copyUrlAutomatically.bind(this);
    // }
    /**
     * Callback invoked to copy the url to clipboard.
     *
     * @returns {void}
     */
    const _copyUrl = async () => {
        const success = await copyText(props.url);
        if (success) {
            _showLinkCopied();
            window.setTimeout(_hideLinkCopied, COPY_TIMEOUT);
        }
    };
    /**
     * Hides the 'Link copied' message.
     *
     * @private
     * @returns {void}
     */
    const _hideLinkCopied = () => {
        setShowLinkCopied(false);
    };
    /**
     * Hides the 'Copy link' text.
     *
     * @private
     * @returns {void}
     */
    const _hideCopyLink = () => {
        setShowLinkCopied(false);
        setShowCopyLink(false);
    };
    /**
     * Shows the dark 'Copy link' text on hover.
     *
     * @private
     * @returns {void}
     */
    const _showCopyLink = () => {
        setShowCopyLink(true);
        setShowLinkCopied(false);
    };
    /**
     * Shows the green 'Link copied' message.
     *
     * @private
     * @returns {void}
     */
    const _showLinkCopied = () => {
        setShowCopyLink(false);
        setShowLinkCopied(true);
    };
    /**
     * Attempts to automatically copy invitation URL.
     * Document has to be focused in order for this to work.
     *
     * @private
     * @returns {void}
     */
    const _copyUrlAutomatically = () => {
        navigator.clipboard.writeText(props.url).then(() => {
            _showLinkCopied();
            window.setTimeout(_hideLinkCopied, COPY_TIMEOUT);
        });
    };
    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately before mounting occurs.
     *
     * @inheritdoc
     */
    useEffect(() => {
        if (props._enableAutomaticUrlCopy) {
            setTimeout(_copyUrlAutomatically, 2000);
        }
    }, []);
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    const src = showLinkCopied ? IconCheck : IconCopy;
    const { url, t, classes } = props;
    return (React.createElement("div", { className: cx('copy-meeting', classes.root), onMouseEnter: _showCopyLink, onMouseLeave: _hideCopyLink },
        React.createElement("div", { className: `url ${showLinkCopied ? 'done' : ''}`, onClick: _copyUrl },
            React.createElement("div", { className: 'copy-meeting-text' },
                !showCopyLink && !showLinkCopied && getDecodedURI(url),
                showCopyLink && t('prejoin.copyAndShare'),
                showLinkCopied && t('prejoin.linkCopied')),
            React.createElement(Icon, { onClick: _copyUrl, size: 24, src: src })),
        React.createElement("textarea", { readOnly: true, ref: textarea, tabIndex: -1, value: url })));
};
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const { enableAutomaticUrlCopy } = state['features/base/config'];
    const { customizationReady } = state['features/dynamic-branding'];
    let url = APP.store.getState()['features/base/config'].cnameUrl;
    if (!url) {
        url = customizationReady ? getCurrentConferenceUrl(state) : '';
    }
    return {
        url,
        _enableAutomaticUrlCopy: enableAutomaticUrlCopy || false,
    };
}
export default withStyles((theme) => ({
    root: {
        "& .url:hover": {
            backgroundColor: theme.palette.iisightBrand
        }
    },
}))(connect(mapStateToProps)(translate(CopyMeetingUrl)));
